import avatar1 from 'assets/img/avatars/1.jpg';
import avatar2 from 'assets/img/avatars/2.jpg';
import avatar3 from 'assets/img/avatars/3.jpg';
import avatar4 from 'assets/img/avatars/4.jpg';
import avatar5 from 'assets/img/avatars/5.jpg';
import avatar6 from 'assets/img/avatars/6.jpg';
import avatar7 from 'assets/img/avatars/7.jpg';
import avatar8 from 'assets/img/avatars/8.jpg';
import favicon from 'assets/img/favicon.ico';
const imageAssets = {
    avatar1,
    avatar2,
    avatar3,
    avatar4,
    avatar5,
    avatar6,
    avatar7,
    avatar8,
    favicon,
};

export default imageAssets;
